<template>
	<div>
		<div class="detail-modal" v-if="!config.isComfirm">
			<div class="modal">
				<div class="modal-head">提示</div>
				<div class="modal-body">{{config.content}}</div>
			</div>
		</div>
		<div class="detail-modal" v-if="config.isComfirm">
			<div class="modal">
				<div class="modal-head">提示</div>
				<div class="modal-body">{{config.content}}</div>
				<div class="modal-foot">
					<div class="btn-s" @click="ok">{{config.yes||'确定'}}</div>
					<div class="btn-s btn-back" @click="close">{{config.no||'返回'}}</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
	export default{ 
		name:'modal',
		props:{
			config: {
                type: Object,
                default: function(){
                	return{}
                }
            }
		},
		methods:{
			ok(){
				this.$emit('ok')
			},
			close(){
				this.$emit('close')
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/common/cmpnt/Modal/modal.vue